import { useDarkmode } from "hooks/useTheme";
import ReactApexChart from "react-apexcharts";

const chartData = [44, 55, 13, 3, 24, 98];

function ServingInterests() {
  const { darkmode } = useDarkmode();

  const chartOptions = {
    labels: [
      "Teaching or mentoring",
      "Hospitality",
      "Technical support",
      "Community outreach",
      "Music or arts",
      "Other",
    ],
    tooltip: {
      enabled: false,
    },
    dataLabels: {
      enabled: false,
    },
    plotOptions: {
      pie: {
        // customScale: 0.5,
        expandOnClick: false,
        donut: {
          size: "75%",
          labels: {
            show: true,
            name: {
              fontWeight: 400,
              fontSize: "14px",
              offsetY: -5,
              color: "#A3AED0",
            },
            value: {
              fontSize: "22px",
              fontWeight: 600,
              offsetY: 5,
              formatter: (v, opts) => {
                const total = opts.globals.series.reduce((sum, x) => {
                  return sum + x;
                }, 0);
                const val = total > 0 ? parseInt((100 * v) / total) : 0;
                return val.toString() + " %";
              },
              color: darkmode ? "white" : "#A3AED0",
            },
            total: {
              show: true,
              color: "#A3AED0",
            },
          },
        },
      },
    },
    legend: {
      show: true,
      horizontalAlign: "center",
      position: "right",
      fontWeight: 600,
      fontSize: "14px",
      height: "100%",
      formatter: (label, opts) => {
        return (
          '<span class="dark:text-white">' +
          label +
          '</span><span class="font-normal ml-[10px] text-gray-600">' +
          opts.w.globals.series[opts.seriesIndex] +
          "</span>"
        );
      },
      markers: {
        strokeWidth: 0,
        offsetX: -5,
        size: 5,
      },
      itemMargin: {
        horizontal: 15,
      },
    },
    grid: {
      show: false,
    },
    states: {
      hover: { filter: "none" },
      active: { filter: "none" },
    },
  };

  const newOptions = {
    ...chartOptions,
    colors: ["#91B9A8", "#EF9C8F", "#FFC69B", "#9BC0FF", "#CED7EE", "#909BB8"],
  };

  //   return (
  //     <>
  //       <div className="flex-1 relative items-center rounded-[30px] p-[30px] gap-[30px] shadow-atrium shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none">
  //         {/* header */}
  //         <div className="flex flex-wrap">
  //           <div className="flex-1">
  //             <p className="text-gray-800 font-bold dark:text-white">
  //               Serving interests
  //             </p>
  //             <p className="text-gray-600 text-sm">
  //               Distribution of members' serving interests
  //             </p>
  //           </div>
  //           <div>
  //             <select className="bg-[transparent] h-12 text-sm text-gray-700 rounded-xl pr-4 outline-none rounded-2xl p-[8px] mr-4">
  //               <option>All ministries</option>
  //             </select>
  //           </div>
  //           <div>
  //             <select className="bg-[transparent] h-12 text-sm text-gray-700 rounded-xl pr-4 outline-none rounded-2xl p-[8px] mr-4">
  //               <option>All departments</option>
  //             </select>
  //           </div>
  //         </div>

  //         {/* chart */}
  //         <div className="block h-[300px]">
  //           <div className="w-full h-full">
  //             <ReactApexChart
  //               options={newOptions}
  //               series={chartData}
  //               type="donut"
  //               width="100%"
  //               height="100%"
  //             />
  //           </div>
  //         </div>
  //       </div>
  //     </>
  //   );
  return (
    <>
      <div className="flex-1 relative items-center rounded-[30px] p-4 md:p-[30px] gap-4 md:gap-[30px] shadow-atrium shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none">
        {/* header */}
        <div className="flex flex-col md:flex-row md:items-center md:justify-between flex-wrap gap-4 mb-4">
          <div className="flex-1 min-w-[200px]">
            <p className="text-gray-800 font-bold dark:text-white">
              Serving interests
            </p>
            <p className="text-gray-600 text-sm">
              Distribution of members' serving interests
            </p>
          </div>

          <div className="flex flex-row gap-2 sm:gap-4">
            <select className="bg-transparent h-12 text-sm text-gray-700 rounded-2xl px-4 outline-none border border-gray-300 dark:border-gray-600">
              <option>All ministries</option>
            </select>
            <select className="bg-transparent h-12 text-sm text-gray-700 rounded-2xl px-4 outline-none border border-gray-300 dark:border-gray-600">
              <option>All departments</option>
            </select>
          </div>
        </div>

        {/* chart */}
        <div className="w-full h-[350px] sm:h-[300px] md:h-[350px]">
          <ReactApexChart
            options={newOptions}
            series={chartData}
            type="donut"
            width="100%"
            height="100%"
          />
        </div>
      </div>
    </>
  );
}

export default ServingInterests;
